import {BillingInfo} from '@eitje/api'
import {BillingInfoDropdownItem, EnvironmentDropdownItem, OrganisationDropdownItem} from './dropdown_items'

export const BillingInfoDropdown = ({id}) => {
	const {environment_ids, organisation_id} = BillingInfo.useFind(id)
	return (
		<>
			<BillingInfoDropdownItem id={id} icon="eye-open" />
			<EnvironmentDropdownItem ids={environment_ids} />
			<OrganisationDropdownItem id={organisation_id} />
		</>
	)
}
